// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3Rf7h","addWidgetButton":"Header_addWidgetButton__2Yc5l","dashboardTabs":"Header_dashboardTabs__1UT0D","active":"Header_active__l54BM"};